import { useLocation } from 'react-router-dom';

export function useQueryParams(name: string) {
  const { search } = useLocation();
  return new URLSearchParams(search).get(name);
}
